import { render } from "./sesso.vue?vue&type=template&id=00a5b3d4&ts=true"
import script from "./sesso.vue?vue&type=script&lang=ts"
export * from "./sesso.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__